// @flow
import {
  SET_LICENCE_EMAIL_NOTIFICATION,
  UPDATE_LICENCE_EMAIL_NOTIFICATION,
  PATCH_LICENCE_EMAIL_NOTIFICATION,
  REMOVE_LICENCE_EMAIL_NOTIFICATION,
  CLEAR_LICENCE_EMAIL_NOTIFICATION
} from "../../global/actions/actionNames";
import type { EmailNotificationType } from "../actions/emailNotificationActions";

type EmailNotificationStateType = {
  notification: ?EmailNotificationType
};

const initialState: EmailNotificationStateType = {
  notification: null
};

export default function emailNotificationReducer(
  state: EmailNotificationStateType = initialState,
  action: any
): EmailNotificationStateType {

  switch (action.type) {
    case SET_LICENCE_EMAIL_NOTIFICATION:
    case UPDATE_LICENCE_EMAIL_NOTIFICATION:
    case PATCH_LICENCE_EMAIL_NOTIFICATION:
      return { ...state, notification: action.payload };
    case REMOVE_LICENCE_EMAIL_NOTIFICATION:
      return { ...state, notification: null };
    case CLEAR_LICENCE_EMAIL_NOTIFICATION:
      return { ...state, notification: null };
    default:
      return state;
  }
}